<template>
    <v-container>
      <div class="esign-backbar">
        <v-btn text class="esign-back-btn" @click="back()">
          <v-icon left>mdi-arrow-left</v-icon> Kembali
        </v-btn>
      </div>
      <div class="mb-5">
        <material-card color="primary" title="Detail Organisasi (PAU/Fakultas/Sekolah)" class="card-wrapper">
          <v-form>
            <v-row>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Kode Organisasi (PAU/Fakultas/Sekolah)</p>
                  <v-text-field
                    dense 
                    placeholder="Kode Organisasi (PAU/Fakultas/Sekolah)" 
                    readonly
                    outlined 
                    class="primary--text"
                    v-model="formData.kode_org"
                    @input="$v.formData.kode_org.$touch()"
                    @blur="$v.formData.kode_org.$touch()"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Nama Organisasi (PAU/Fakultas/Sekolah)</p>
                  <v-text-field
                    dense 
                    placeholder="Nama Organisasi (PAU/Fakultas/Sekolah)" 
                    readonly
                    outlined 
                    class="primary--text"
                    v-model="formData.nama"
                    @input="$v.formData.nama.$touch()"
                    @blur="$v.formData.nama.$touch()"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Parent</p>
                  <v-text-field
                    dense 
                    placeholder="Parent" 
                    readonly
                    outlined 
                    class="primary--text"
                    v-model="parentDisplay"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Level</p>
                  <v-text-field
                    dense 
                    placeholder="Level" 
                    readonly
                    outlined 
                    class="primary--text"
                    v-model="formData.level"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">File Stamp</p>                  
                  <p v-if="this.formData.file_stamp == '' " class="label">Organisasi (PAU/Fakultas/Sekolah) ini tidak memiliki File Stamp</p>
                  <a v-if="this.formData.file_stamp !== '' " v-bind:href="filestampimg" v-bind:download="formData.file_stamp"> {{ this.formData.file_stamp }}</a> &nbsp;
                  <v-btn v-if="this.formData.file_stamp !== '' " small color="primary" dark @click="showFileStamp()">Lihat Gambar</v-btn>&nbsp;
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Status</p>
                  <v-checkbox v-model="formData.status" 
                    v-if="formData.status === true" label="Aktif" 
                    readonly
                    outlined 
                    class="primary--text"/> 
                  <v-checkbox v-model="formData.status" 
                    v-else-if="formData.status === false" label="Tidak Aktif" 
                    readonly
                    outlined 
                    class="primary--text"/>
                </div>
              </v-col>
              <v-col cols="12" class="text-right">
                <v-btn v-if="currentPeran ==='A01' || currentPeran ==='A05'" color="orange" dark @click="editItem()">Ubah</v-btn>&nbsp
              </v-col>
            </v-row>
          </v-form>
          <v-dialog v-model="dialog" max-height="800px" max-width="800px">
          <v-card class="card-modal" style="box-shadow:none!important;">
            <v-toolbar
              dark
              color="primary"
            >
              
              <v-toolbar-title>File Stamp Organisasi (PAU/Fakultas/Sekolah)</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon
                  dark
                  @click="dialog = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <div class="text-center mt-6 mb-6">
              <img v-if="filestampimg && !filestampError" :src="filestampimg" alt="File Stamp Organisasi (PAU/Fakultas/Sekolah)" class="esign-stamp-preview" @error="filestampError = true">
              <p v-else class="esign-stamp-missing">
                <v-icon color="error">mdi-image-broken-variant</v-icon>
                Gambar file stamp tidak dapat dimuat. Pastikan file masih tersedia di server, lalu unggah ulang bila perlu.
              </p>
            </div>
          </v-card>
        </v-dialog>
        </material-card>
      </div>

    </v-container>
  </template>
  
<script>
  import { apiServer } from "../../setup-axios";
  import { backendUrl } from "../../config/env";
  export default {
    data: () => ({
      filestampimg: null,
      filestampError: false,
      dialog: false,
      currentPeran: "",
      formData: {
        id: null,
        nama: null,
        kode_org: null,
        status: null,
        file_stamp: null,
        level: null,
        organisasi_parent: {
          id: null,
          nama: null,
          kode_org: null,
        },
      },
    }),
    mounted() {
      console.log("loading")
      this.getData();
      this.fetchFileStamp();
      this.currentPeran = localStorage.getItem("currentPeran")
      console.log("current peran " + this.currentPeran)
    },
    computed: {
      parentDisplay() {
        if (this.formData.organisasi_parent) {
          return `${this.formData.organisasi_parent.nama} - ${this.formData.organisasi_parent.kode_org}`;
        }
        return '';
      },
    },
    methods: {
      getData() {
        console.log("get data " + this.$route.params.kodeorg)
        apiServer
          .get("/organisasi/kode/" + this.$route.params.kodeorg)
          .then(response => {
            console.log(response.data.data)
            this.formData = response.data.data;
            console.log(this.formData)
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
      },
      fetchFileStamp() {
        console.log("show image " +this.formData.file_stamp)
        var timestamp = new Date().getTime() // get current timestamp
        apiServer
          .get("/organisasi/filestamp/" + this.$route.params.kodeorg+ "?timestamp="  + timestamp,{ responseType: 'blob' })
          .then(response => {
            this.filestampError = false
            this.filestampimg = URL.createObjectURL(response.data)
          })
        // this.filestampimg = backendUrl + "/organisasi/filestamp/" + this.$route.params.kodeorg
        // this.dialog = true;
      },
      showFileStamp() {
        this.dialog = true;
      },
      editItem(){
        console.log("edit item " + this.$route.params.kodeorg)
        this.$router.push('/ubah-organisasi/' + this.$route.params.kodeorg);
      },
      back() {
        this.$router.push('/organisasi')
      },
      close() {
        this.dialog = false;
      },
    }
  }
</script>
  